import { Button, Row, Space, Table } from "antd";
import { ExcelSVG } from "assets";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { apoitmentColumns, fields as fieldsList } from "../config";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { setActiveKey, setIdPhieuKham } from "redux/reducer/common";

import customerCare from "api/customerCare";
import {
  ExpandSearch,
  ListActionButton,
  Notification,
} from "components/common";
import dayjs from "dayjs";
import { exportFile, formatDateToString } from "helper/common";
import { setIdConsultantAndFragment } from "redux/reducer/consultantAndFragment";
import { tabKeys } from "types/enums";
import { consultantAndFragmentService } from "api";

const ApoitmentPatient = () => {
  const [params, setParams] = useState<any>({
    page: 1,
    limit: 10,
    ngayHenPTTu: dayjs(),
    ngayHenPTDen: dayjs(),
  });
  const dispatch = useAppDispatch();
  const [total, setTotal] = useState();

  const [loadingInfo, setLoadingInfo] = useState(false);
  const [data, setData] = useState(null);
  const onChangePagination = (page, pageSize) => {
    setParams({ ...params, page: page, limit: pageSize });
  };
  const expandRef = useRef<any>();

  const formatParams = () => {
    return {
      ...params,
      ngaySinh: formatDateToString(params.ngaySinh),
      ngayHenPTTu: formatDateToString(params.ngayHenPTTu),
      ngayHenPTDen: formatDateToString(params.ngayHenPTDen),
      loaiCSKH: 0,
    };
  };
  const getList = async () => {
    setLoadingInfo(true);

    try {
      const res = await customerCare.getLitCustomerCare(formatParams());
      const newData = res.data.map((item) => {
        return {
          ...item,
          key: item.id,
        };
      });

      setData(newData);
      setTotal(res.total);

      setLoadingInfo(false);
    } catch (error) {
      setLoadingInfo(false);

      Notification("error", "Đã có lỗi xảy ra khi tải dữ liệu");
    }
  };
  const handleOnExport = async () => {
    const params = formatParams();
    if (!params.ngayHenPTTu || !params.ngayHenPTDen) {
      Notification("warning", "Chưa chọn thời gian xuất báo cáo");
    } else {
      exportFile(
        "qlkhambenh/phieu-cskh/export-list-phieu-cskh",
        formatParams(),
        "Báo cáo bệnh nhân có lịch phẫu thuật"
      );
    }
  };
  useEffect(() => {
    getList();
  }, [params]);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>();
  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
      console.log("🚀 ~ ApoitmentPatient ~ selectedRows:", selectedRows);
      handleEdit(selectedRows[0].idPhieuTuVan);
      setSelectedRowKeys(selectedRowKeys);
      dispatch(setIdPhieuKham(selectedRows[0].idPhieuKham));
    },
  };
  const onClickSearchButton = () => {
    var searchFields = expandRef.current?.getData();
    setParams({
      ...params,
      ...searchFields,
      page: 1,
    });
  };
  apoitmentColumns.find((e) => (e.dataIndex = "stt")).render = (v, r, i) => {
    const index = (params.page - 1) * params.limit + i + 1;
    return index;
  };
  apoitmentColumns.find((e) => e?.dataIndex == "action").render = (
    value,
    _record: any,
    index
  ) => {
    return (
      <ListActionButton
        deleteFunction={() => {
          handleDelete(_record?.id);
        }}
      ></ListActionButton>
    );
  };
  const handleDelete = async (id) => {
    try {
      await consultantAndFragmentService.deleteBNCoLichPT(id);
      getList();
    } catch (error) {
      Notification("error", error?.response?.data ?? "Đã có lỗi");
    }
  };
  const handleEdit = (id) => {
    if (id) {
      dispatch(setIdConsultantAndFragment(id));
    } else {
      Notification("warning", "Bệnh nhân chưa có phiếu tu vấn");
      dispatch(setIdConsultantAndFragment(null));
    }
  };

  return (
    <div>
      <div className="container">
        <Row gutter={[16, 8]}>
          <ExpandSearch
            ref={expandRef}
            onClickSearch={onClickSearchButton}
            fields={fieldsList()}
            onReset={() => {
              onClickSearchButton();
            }}
            initialValues={params}
          />
        </Row>
      </div>
      <div className="container">
        <Space direction="vertical" style={{ width: "100%" }}>
          <Row justify={"start"}>
            <Button
              icon={<ExcelSVG />}
              className="custom-btn"
              onClick={handleOnExport}
            >
              Xuất báo cáo
            </Button>
          </Row>
          <Table
            columns={apoitmentColumns}
            dataSource={data}
            loading={loadingInfo}
            pagination={{
              position: ["bottomRight"],
              showSizeChanger: true,
              total: total,
              current: params.page,
              onChange: onChangePagination,
            }}
            rowSelection={{
              type: "radio",
              ...rowSelection,
            }}
            onRow={(record) => ({
              onDoubleClick: () => {
                if (record.idPhieuTuVan) {
                  dispatch(
                    setActiveKey(
                      tabKeys.CONSULTANT_AND_FRAGMENT
                        .DETAIL_CONSULTANT_AND_FRAGMENT
                    )
                  );
                  dispatch(setIdConsultantAndFragment(record.idPhieuTuVan));
                } else {
                  Notification("warning", "Bệnh nhân chưa có phiếu tư vấn");
                }
              },
            })}
            scroll={{ x: "100%" }}
            bordered
          />
        </Space>
      </div>
    </div>
  );
};

export default ApoitmentPatient;
